module.exports = __webpack_public_path__ + "img/01.d2b2d4c8.png";